export const customGetCustomerOrdersQuery = `
  query customerOrders($currentPage: Int = 1, $filter: CustomerOrdersFilterInput = {}, $pageSize: Int = 10) {
    customer {
      orders(currentPage: $currentPage, filter: $filter, pageSize: $pageSize) {
        items {
          number
          id
          order_date
          grand_total
          total {
            discounts {
              amount {
                currency
                value
              }
              label
            }
            base_grand_total {
              currency
              value
            }
            shipping_handling {
              amount_excluding_tax {
                currency
                value
              }
              amount_including_tax {
                currency
                value
              }
              discounts {
                amount {
                  currency
                  value
                }
              }
              taxes {
                amount{
                  currency
                  value
                }
                rate
                title
              }
              total_amount {
                currency
                value
              }
            }
            subtotal {
              currency
              value
            }
            taxes {
              amount {
                currency
                value
              }
              rate
              title
            }
            total_shipping {
              currency
              value
            }
            total_tax {
              currency
              value
            }
          }
          status
          comments {
            message
            timestamp
          }
          invoices {
            comments {
              message
              timestamp
            }
            id
            items {
              discounts {
                amount {
                  currency
                  value
                }
                label
              }
              id
              product_name
              product_sale_price {
                currency
                value
              }
              product_sku
              quantity_invoiced
            }
            number
            total {
              discounts {
                amount {
                  currency
                  value
                }
                label
              }
              base_grand_total {
                currency
                value
              }
              shipping_handling {
                amount_excluding_tax {
                  currency
                  value
                }
                amount_including_tax {
                  currency
                  value
                }
                discounts {
                  amount {
                    currency
                    value
                  }
                }
                taxes {
                  amount{
                    currency
                    value
                  }
                  rate
                  title
                }
                total_amount {
                  currency
                  value
                }
              }
              subtotal {
                currency
                value
              }
              taxes {
                amount {
                  currency
                  value
                }
                rate
                title
              }
              total_shipping {
                currency
                value
              }
              total_tax {
                currency
                value
              }
            }
          }
          items {
            discounts {
              amount {
                currency
                value
              }
              label
            }
            id
            product_name
            product_sale_price {
              currency
              value
            }
            product_sku
            product_url_key
            product {
              ... on ConfigurableProduct {
                variants {
                  product {
                    sku
                    delivery_type
                    stock_status
                    only_x_left_in_stock
                    thumbnail {
                      url
                    }
                  }
                }
              }
              uid
              sku
              name
              stock_status
              delivery_type
              license_expiration_date
              license_beginning_date
              active_versions {
                digital {
                  version_name
                  sku
                  is_singular_version
                }
                physical {
                  version_name
                  sku
                  is_singular_version
                }
              }
              only_x_left_in_stock
            }

            quantity_canceled
            quantity_invoiced
            quantity_ordered
            quantity_refunded
            quantity_returned
            quantity_shipped
            status
          }
          payment_methods {
            name
            type
            additional_data {
              name
              value
            }
          }
          shipments {
            comments {
              message
              timestamp
            }
            id
            number
            tracking {
              carrier
              number
              title
            }
            items {
              id
              product_name
              product_sale_price {
                currency
                value
              }
              product_sku
              quantity_shipped

              order_item {
                product_name
                quantity_canceled
                quantity_invoiced
                quantity_ordered
                quantity_refunded
                quantity_returned
                quantity_shipped
                status
              }
            }
          }
          shipping_address {
            city
            address_line_2
            address_line_3
            sap_name
            country_code
            firstname
            lastname
            company
            postcode
            prefix
            street
            suffix
            telephone
          }
          billing_address {
            city
            address_line_2
            address_line_3
            sap_name
            country_code
            firstname
            lastname
            company
            postcode
            prefix
            street
            suffix
            telephone
          }
          shipping_method
        }
        page_info {
            current_page
            total_pages
            page_size
        }
        total_count
      }
    }
  }
`;
